import { Select } from '@arco-design/web-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilters } from '@/context/FilterContext';
import { useMensalidades } from '@/context/MensalidadesContext';

export function SupplierMultiSelect() {
  const { filters, dispatch } = useFilters();
  const { state } = useMensalidades();
  const { t } = useTranslation();

  const options = useMemo(() => {
    const set = new Set<string>();
    for (const tx of state.transactions) set.add(tx.supplier);
    return [...set].sort((a, b) => a.localeCompare(b, 'pt-PT'));
  }, [state.transactions]);

  return (
    <div className="aiobi-filter">
      <label className="aiobi-filter__label">{t('filters.suppliers.label')}</label>
      <Select
        mode="multiple"
        value={filters.suppliers}
        onChange={(v) => dispatch({ type: 'SET_SUPPLIERS', payload: v as string[] })}
        placeholder={t('filters.suppliers.placeholder')}
        showSearch
        allowClear
        size="small"
        style={{ minWidth: 220, maxWidth: 320 }}
        options={options.map((s) => ({ label: s, value: s }))}
      />
    </div>
  );
}
